import React from 'react';
import { resolveImageUrl } from '../../../utils/imageUrl.js';
import productDefaultImg from '../../../assets/product-default.png';
import serviceDefaultImg from '../../../assets/service-default.png';

const defaultImageFor = (item) =>
  String(item?.type || '').toLowerCase() === 'service' ? serviceDefaultImg : productDefaultImg;

export default function RoomGrid({
  rooms = [],
  itemsBySection = new Map(),
  onSelectRoom,
  deleteMode = false,
  selectedToDelete = [],
  onToggleSelect,
}) {
  return (
    <div className="library-room-grid">
      {rooms.map((room) => {
        const roomItems = itemsBySection.get(room.sectionId) || [];

        let displayImages = [];
        if (roomItems.length === 0) {
          displayImages = ['placeholder'];
        } else if (roomItems.length === 1) {
          displayImages = [resolveImageUrl(roomItems[0], defaultImageFor(roomItems[0]))];
        } else {
          const images = roomItems.map((i) => resolveImageUrl(i, defaultImageFor(i)));
          displayImages = images.slice(0, 2);
        }

        const isSelected = selectedToDelete.includes(room.sectionId);
        const hasSingle = displayImages.length === 1 && displayImages[0] !== 'placeholder';

        return (
          <div
            key={room.sectionId}
            className={`library-room-card ${deleteMode ? 'delete-mode' : ''} ${
              isSelected ? 'selected' : ''
            }`}
          >
            <div
              className="library-room-click"
              onClick={() => {
                deleteMode
                  ? onToggleSelect(room.sectionId)
                  : onSelectRoom({ ...room, items: roomItems });
              }}
            />

            {deleteMode && (
              <div
                className={`room-select-circle ${isSelected ? 'checked' : ''}`}
                onClick={() => onToggleSelect(room.sectionId)}
              >
                <div className="inner" />
              </div>
            )}

            <div
              className={`library-room-images ${
                hasSingle ? 'library-single-image' : 'library-multiple-images'
              }`}
            >
              {displayImages.map((img, idx) =>
                img === 'placeholder' ? (
                  <div key={idx} className="library-placeholder-block" />
                ) : (
                  <img key={idx} src={img} alt={room.name} />
                )
              )}
            </div>

            <p className="library-room-name">{room.name}</p>
          </div>
        );
      })}
    </div>
  );
}
